import React, { Component } from 'react';
import { CONFIG_TABS } from '../constants';
type Props = {
  selectedBoticonurl: string;
  selectedBotname: string;
  selectTab: Function;
  selectedTab: string;
};

type State = {};

export default class ConfigHeader extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
  }
  setInitialState(): State {
    return {
      selectedBoticonurl: '',
    };
  }
  TABS = CONFIG_TABS[1];
  render() {
    return (
      <div className='config-header'>
        <div className='bot-details' style={{ marginLeft: '36.5px' }}>
          <img
            src={this.props.selectedBoticonurl}
            alt='boticon url'
            className='img-wrapper'
          />
          <div
            className='bot-name'
            style={{
              marginLeft: '10px',
              fontWeight: 600,
              fontSize: '24px',
              lineHeight: '4.33',
            }}>
            {this.props.selectedBotname}
          </div>
        </div>
        <div className='panel-tabs'>
          {this.TABS.map((tab, index) => {
            return (
              <div
                key={index}
                className={
                  'each-panel-tabs clickable' +
                  (this.props.selectedTab === tab ? ' selected' : '')
                }
                onClick={() => {
                  this.props.selectTab(tab);
                }}>
                {tab}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
